/**
 * Stripe Checkout não permite carregar dentro de iframes (frame-ancestors: 'none').
 * No preview do Emergent o app roda dentro de iframe — `window.location.href` muda só o iframe
 * e a página fica eterna em "carregando".
 *
 * Esta função força o redirect no TOP frame (escapa do iframe). Em produção também funciona
 * porque `window.top === window` quando não há iframe.
 */
export function redirectToCheckout(url) {
  if (!url) return false;
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
      return true;
    }
  } catch {
    // cross-origin: cai no fallback
  }
  try {
    const w = window.open(url, "_top");
    if (w) return true;
  } catch {}
  window.location.href = url;
  return true;
}
